import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { Feed } from '@app/models/Feed';
import { FeedItem } from '@app/models/feed-item';
import { FeedInfo } from '@app/models/feed-source-info';
import { CacheService } from '@app/services/cache.service';
import { concat, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Injectable({
  providedIn: 'root'
})
export class FeedService {

  constructor(private featureSettingsStoreService: FeatureSettingsStoreService, private http: HttpClient, private cache: CacheService, private httpHelper: HttpHelper) { }
  private readonly cacheKey = 'RssFeedService-getRssFeeds';

  public useCache = true;

  getRssFeeds(feedsInfo: Array<FeedInfo>, numberOfFeedsToFetch: number): Observable<Array<FeedItem>> {

    const paramsFeedUrls = feedsInfo.map(feed => {
      return encodeURI(feed.FeedLink);
    });

    const paramsTagNames = feedsInfo.map(feed => {
      return feed.TagName;
    });

    const httpParams = new HttpParams()
      .append('feedUrls', paramsFeedUrls.join(', '))
      .append('amount', numberOfFeedsToFetch.toString())
      .append('feedTagNames', paramsTagNames.join(', '));

    const fetchOperation = this.http.get<any>(`${Constants.API_ENDPOINT}/Feed`,
      {
        params: httpParams
      })
      .pipe(
        map(data => {
          // console.log('RssFeeds' + data);
          const results = data as Array<Feed>;
          let allFeedItems = new Array<FeedItem>();
          results.forEach(items => {
            const tmp = items.Items;
            allFeedItems = allFeedItems.concat(tmp);
          });
          const allFeedsWithTitle = allFeedItems.filter(f => f.Title !== '');
          const descendingResult = allFeedsWithTitle.sort((a, b) => (a.PublishedDate < b.PublishedDate) ? 1 : ((b.PublishedDate < a.PublishedDate) ? -1 : 0));
          return descendingResult;
        }),
        tap(data => {
          this.useCache && this.cache.set(this.cacheKey, data);
        }),
        catchError(this.httpHelper.handleError({ operation: 'getRssFeeds', result: new Array<FeedItem>(), cacheKey: this.cacheKey })));

    if (this.useCache) {
      const cachedData = this.cache.get<Array<FeedItem>>(this.cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }
    return fetchOperation;
  }

}
